module.exports = __webpack_public_path__ + "img/ic_12_flame.58a1c5c4.svg";